/* eslint-disable react/prop-types */
import Link from '@base/Link/Link';
import EducatorDetailedCard from '@comp/EducatorDetailedCard/EducatorDetailedCard';
import { Spacings } from '@styles/index';
import camelCase from 'camelcase-keys';
import CardHeader from './CardHeader';

const linkStyle = `
  margin-top: ${Spacings.SPACING_3B};
  margin-bottom: ${Spacings.SPACING_3B};
`;

const NewEducatorCard = ({ story }) => {
  const { message, created_at, object } = story;
  if (!object) return;
  const educator = camelCase(object, { deep: true });

  const href = '/[authorID]';
  const as = `/@${educator.username}`;

  return (
    <Link as={as} href={href} newTab>
      <CardHeader
        message={message}
        img="newclass.svg"
        created_at={created_at}
      />
      <EducatorDetailedCard
        gridColumn="span 10"
        key={1}
        educator={educator}
        showBadge
        linkStyle={linkStyle}
      />
    </Link>
  );
};

export default NewEducatorCard;
